import React, { useEffect, useState } from 'react';
import ClaycoForm from '../../components/form_elements/clayco-form';
import Header from '../../components/header';
import Beneficiaries from '../lifeInsurance/beneficaries';
import {  Button } from 'carbon-components-react';
import { Add16 } from "@carbon/icons-react";
import { BeneficiaryType } from '../../components/enums/beneficiary-type';
import BeneficiaryEdit from '../lifeInsurance/beneficiary-edit';
import FormSignature from '../../components/form_elements/form-signature';
import SubmitButton from '../../components/form_elements/submit-button';
import { useDispatch, useSelector } from 'react-redux';
import { updateEnrollments } from '../../redux/actions/enrollments-actions';
import { setAdminSessions } from '../../redux/actions/admin-actions';
import { useNavigate } from 'react-router';
import useMsalApi from '../../components/use-msal-api';
import * as Yup from 'yup';
import { OptionalNumber, OptionalString } from '../../components/form_elements/form-validators';
import { PlanType } from '../../components/enums/plan-type';
import { buildBeneficiaries } from '../../components/contact-builder';
import Initialize from '../../components/initilize';
import { format, parseISO } from 'date-fns';

const BeneficiariesPage = () => {
    const [beneficiary, setBeneficiary] = useState();
    const [beneficiaries, setBeneficiaries] = useState([]);
    const [show, setShow] = useState();
    const [submitting, setSubmitting] = useState(false);
    const enrollments = useSelector(s => s.enrollments);
    const dispatch = useDispatch();
    const admin = useSelector(s => s.admin);
    const navigate = useNavigate();
    const [callApi] = useMsalApi();
    const [isEmployee, setIsEmployee] = useState(false);

    useEffect(() => {
        if(Array.isArray(enrollments)){
            navigate('/'); 
        }
        console.log(enrollments);
        setBeneficiaries(buildBeneficiaries(enrollments));
    }, [enrollments]);
    useEffect(() => {
        if(!Array.isArray(enrollments))
            return;
        Initialize(callApi, dispatch, navigate);
    }, [])

    const validationSchema = Yup.object().shape({
        signature: OptionalString().test("signature-required", "Required",  (item) => {
            if(admin.isAdmin === true)
                return true;
            return !!item;
        }),
        primaryPercentage: OptionalNumber().test("primary-percent", "% of Benefit must equal 100%",
        () => {
          const primaries = beneficiaries?.filter(s => s.type === 1);
          if(primaries.length === 0)
            return false;
        else {
                var amount = primaries?.map(item => item.percentage).reduce((prev, next) => prev + next);
                    return  amount === 100;
                }
            }
        ),
        contingentPercentage: OptionalNumber().test("contingent-percent", "Sum of Benefit % must equal 100%",
        () => {
            const contingents = beneficiaries?.filter(s => s.type === 2);
            if(contingents.length === 0)
                return true;
            else {
                var amount = contingents?.map(item => item.percentage).reduce((prev, next) => prev + next);
                return  amount === 100;
            }
        })
  
    });

    const onSubmit = async(formData) => {
        setSubmitting(true);
        const basicLife = enrollments.plans.find(s => s.planType === PlanType.BeneficiaryLife);

    

        let lifeBasic = {
            planId: basicLife.id,
            planDescription: basicLife.name,
            planType: PlanType.BeneficiaryLife,
            beneficiaries: beneficiaries
          }
              var params = {signature: formData.signature, selection: lifeBasic, contacts: beneficiaries};
        await callApi(`Enrollments/${enrollments.id}/SubmitBeneficiaryChange/${enrollments.employee.id}/${format(
            parseISO(enrollments.effectiveDate),
            "yyyy-MM-dd"
          )}`, "PATCH", params);

        if(admin.isAdmin){
            dispatch(setAdminSessions(admin.sessions.filter(s => s.id !== enrollments.id)))
        } else {
            await Initialize(callApi, dispatch, navigate);
        }
        dispatch(updateEnrollments([]));
        navigate('/BeneficiariesCompleted', {replace:true});

        setSubmitting(false);

    }


    const onError = (errors) => {
        console.log(errors);
    }

    const startOver = async () => {
        setSubmitting(true);
        var path = `Enrollments/${enrollments.id}/${enrollments.employee.id}`;
        if(admin.isAdmin){
            path = `Enrollments/${enrollments.id}`
        }
        var results = await callApi(path, "DELETE");
        if(!results.error){
            if(admin.isAdmin){
                dispatch(updateEnrollments([]));
                dispatch(setAdminSessions(admin.sessions.filter(s => s.id !== enrollments.id)))
                navigate('/Admin', {replace:true});
            } else {
                dispatch(updateEnrollments(results));
                navigate('/', {replace:true});
            }
        }

        setSubmitting(false);
    }

  
    return ( 
        <>
            <ClaycoForm schema={validationSchema} onSubmit={onSubmit} onError={onError}>
            <div className="mt-8">
            <Header title="Beneficiaries" content={<Button kind='ghost' size='sm' renderIcon={Add16} onClick={() => {setBeneficiary({}); setShow(true)}}>Add Beneficiary</Button>} />
            <Beneficiaries beneficiaries={beneficiaries} setBeneficiaries={setBeneficiaries} show={show} setShow={setShow} beneficiary={beneficiary} setBeneficiary={setBeneficiary} type={BeneficiaryType.Primary} setIsEmployee={setIsEmployee}/>
            <Beneficiaries beneficiaries={beneficiaries} setBeneficiaries={setBeneficiaries} show={show} setShow={setShow} beneficiary={beneficiary} setBeneficiary={setBeneficiary} type={BeneficiaryType.Contingent}  setIsEmployee={setIsEmployee} />
            </div>
            
            <hr />

            <div className="my-4">
                This designation will apply to the following Standard Insurance Company coverage(s) if available to you through your
                Employer: Life Insurance, Life with Accidental Death &amp; Dismemberment (AD&amp;D) Insurance and, unless specified otherwise, Supplemental Life Insurance.
            </div>
            <div className="ml-8">
                <ul className="list-disc">
                    <li className="py-2">
                        Your designation revokes all prior designations.
                    </li>
                    <li className="py-2">
                        If the Beneficiary is a trust or trustee, contact the Clayco benefits team.
                    </li>
                    <li className="py-2">
                        Benefits are payable to a contingent Beneficiary only if you are not survived by one or more primary Beneficiaries.
                    </li>
                    <li className="py-2">
                        If a minor (a person not of legal age) or your estate is the Beneficiary, it may be necessary to have a guardian or a
                        legal representative appointed by the court before any death benefit can be paid. 
                    </li>
                    <li className="py-2">
                        A power of attorney must grant specific authority, by the terms of the document or applicable law, to make or change
                        a Beneficiary designation. If you have questions, consult your legal advisor.
                    </li>
                    <li className="py-2">
                        Dependents Insurance and Supplemental Life Insurance on your Spouse, if any, is payable to you, if living, or as
                        provided under your Employer's coverage under the Group Policy.          
                    </li>
                </ul>
                
            </div>

            <FormSignature name="signature" label="Signature" />
            <div className='my-8'>
                <SubmitButton submitting={submitting}>Submit</SubmitButton>
                <Button type="button" onClick={startOver} kind='ghost'>Cancel</Button>
            </div>
            </ClaycoForm>
            <BeneficiaryEdit 
                beneficiaries={beneficiaries} setBeneficiaries={setBeneficiaries} 
                show={show} setShow={setShow} 
                beneficiary={beneficiary} setBeneficiary={setBeneficiary} 
                isEmployee={isEmployee} setIsEmployee={setIsEmployee}
            />
        </>
     );
}
 
export default BeneficiariesPage;